import { Injectable } from '@angular/core';

import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';

import { TransitionService } from '@uirouter/core';
import { BroadcasterService } from 'src/app/shared/services/broadcaster.service';

@Injectable({
  providedIn: 'root',
})
export class PlaceholderService {
  placeholder;

  constructor(
    private transitionService: TransitionService,
    private broadcaster: BroadcasterService,
  ) {
    this.broadcaster.on('presentationUpdated', () => {
      this.clearPlaceholder();
    });

    // This replaces $stateChangeSuccess
    this.transitionService.onSuccess(
      {
        to: (state: any) => state.name !== 'apps.editor.workspace.artboard',
      },
      () => {
        this.clearPlaceholder();
      },
    );
  }

  setPlaceholder(placeholder) {
    this.placeholder = placeholder;
    this.broadcaster.emit('placeholderUpdated');
    this.broadcaster.emit('placeholderSet');
  }

  clearPlaceholder() {
    this.placeholder = undefined;
  }
}

angular
  .module('risevision.editor.services')
  .factory('placeholderFactory', downgradeInjectable(PlaceholderService));
